export default function formatShipmentProductName(product, stock) {
  if (!product) return null;

  const number = product.number || null;
  const name = product.name || null;
  if (!number && !name) return "";

  return (
    <div>
      <span>
        [{number}] {name}
      </span>
      {product.version ? (
        <span className=" whitespace-nowrap"> | v{product.version}</span>
      ) : null}
      {product.itemsPerSet ? (
        <span className="whitespace-nowrap">
          {" "}
          | {product.itemsPerSet} pcs/ctn
        </span>
      ) : null}
      {stock ? <span className="whitespace-nowrap"> | 📦 {stock}</span> : null}
    </div>
  );
}
